import { useCallback } from "react";

import { useAuth } from "../../../context/AuthProvider";
import { useRequest } from "../../../shared/hooks/useRequest";
import { getCheatsheet } from "../api/cheatsheetApi";

export const useCheatsheet = (courseId?: string, cheatsheetId?: string) => {
    const { user } = useAuth();
    const userId = user?.id;

    const fetcher = useCallback(
        (signal: AbortSignal) =>
            getCheatsheet(userId as number | string, courseId as string, cheatsheetId as string, signal),
        [userId, courseId, cheatsheetId]
    );

    return useRequest(userId !== undefined && courseId && cheatsheetId ? fetcher : null);
};